
import About from "./About"
import Section from "./Section"
import HomeEvents from "./HomeEvents"
import HomeNotices from "./HomeNotices"

export default function Home () {
    return (
        <>
         <Section />
         <About/>
         <HomeNotices/>
         <HomeEvents />
        </>
    )
}